import { useEffect, useRef, useState } from "react";
import { ChevronDown, Check } from "lucide-react";

export default function Select({ value, onChange, options, testid }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        data-testid={testid}
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-3 border-2 border-ink/10 rounded-xl px-4 py-3 text-sm bg-white text-ink hover:border-gold transition-colors duration-300"
      >
        <span className="truncate">{value}</span>
        <ChevronDown size={15} className={`shrink-0 text-gold transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          data-testid={`${testid}-options`}
          className="absolute z-40 mt-2 w-full max-h-64 overflow-y-auto bg-white border-2 border-gold/20 rounded-2xl shadow-[0_20px_50px_rgba(9,9,11,0.12)] py-1.5"
        >
          {options.map((o) => (
            <button
              key={o}
              type="button"
              data-testid={`${testid}-option-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              onClick={() => {
                onChange(o);
                setOpen(false);
              }}
              className={`w-full flex items-center justify-between gap-3 px-4 py-2.5 text-sm text-left transition-colors duration-200 ${
                o === value ? "bg-blush font-semibold text-ink" : "text-ink/70 hover:bg-blush/60"
              }`}
            >
              <span className="truncate">{o}</span>
              {o === value && <Check size={14} className="shrink-0 text-gold" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
